import React, { useEffect, useRef, useState } from 'react';
import { IoMdAdd } from "react-icons/io";
import './Ck_DictionaryList.css';
import { useCustomContext } from '../CustomComponents/CustomComponents';
import { FaEdit } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { MdCancel, MdClose } from "react-icons/md";
import CkDictionaryDs from '../../DataServices/CkDictionaryDs';
import { useNavigate } from 'react-router-dom';
import "./Edit.css";
import ViewCk_Dictionary from './ViewCk_Dictionary';
import { insertLog } from '../Logs/InsertLog';
import { CiSearch } from "react-icons/ci";

function Ck_Dictionary() {
    const navigate = useNavigate();
    const CkDs = new CkDictionaryDs()
    const useremail = localStorage.getItem("email");
    const userName = useremail?.split("@")[0];
    const [viewingObject, setViewingObject] = useState('');
    const [isDictionaryModalOpen, setIsDictionaryModalOpen] = useState(false);
    const [dictionariesList, setDictionariesList] = useState([]);
    const { stopHudRotation, hud, showToast, showAlert } = useCustomContext();

    const [allDictionaries, setAllDictionaries] = useState([]);
    const [currentPage, setCurrentPage] = useState(() => {
        const saved = localStorage.getItem('CkDictionaryPage');
        localStorage.removeItem('CkDictionaryPage');
        return saved ? Number(saved) : 1;
    });

    const [pageSize, setPageSize] = useState(25);

    const [search, setSearch] = useState('');
    const [isEditModeOn, setIsEditModeOn] = useState(false);


    const openAddDictionary = () => {
        navigate('/Add_CkDictionary', { state: { openModal: true } })
    }

    const openUpdateDictionary = (id) => {
        localStorage.setItem('CkDictionaryId', id);
        localStorage.setItem('CkDictionaryPage', currentPage);
        navigate('/Add_CkDictionary', { state: { openModal: false } })
    }



    const fetchCkDictionaryLists = async () => {
        // if ( loadedPages.includes(page)) return;

        hud("Please Wait...");


        try {
            const response = await CkDs.CK_Dictionary_List_GET({});
            const data = response.data;

            let body = data.body;

            if (typeof body === "string") body = JSON.parse(body);
            if (typeof body === "string") body = JSON.parse(body);

            console.log("Parsed Body:", body);

            if (data.statusCode === 200 && Array.isArray(body.data)) {
                // const filteredList = body.data.filter(
                //     d => (d?.['ck_dictionary_id'] ?? "").trim() !== ""
                // );

                setAllDictionaries(body.data);

                // insertLog(
                //     `${userName} fetched the Ck Dictionaries`,
                //     0,
                //     useremail,
                //     hud,
                //     stopHudRotation,
                //     showAlert
                // );
            } else {
                showAlert(body?.message || "No dictionaries found", [
                    { label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }
                ]);
                insertLog(
                    `${userName} failed to fetch CK Dictionaries`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    '',
                    'GET',
                    'CK_Dictionary_List_GET',
                    'FAILED',
                    'failed to fetch CK Dictionaries'
                );
            }

        } catch (err) {
            insertLog(
                `${userName} failed to fetch CK Dictionaries`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                '',
                'GET',
                'CK_Dictionary_List_GET',
                'FAILED',
                err.message
            );
            showAlert(err.message || "Something went wrong while fetching Agencies.", [
                { label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }
            ]);
        } finally {
            stopHudRotation();
        }
    };

    useEffect(() => {
        localStorage.removeItem('CkDictionaryId');
        fetchCkDictionaryLists(1);
    }, [])


    const isMounted = useRef(false);

    useEffect(() => {
        if (!isMounted.current) {
            isMounted.current = true;
            return;
        }
        setCurrentPage(1);
    }, [search, pageSize]);

    const handlePageSizeChange = (value) => {
        setPageSize(Number(value));
        setCurrentPage(1);
    };


    const filteredDictionaries = allDictionaries.filter(item => {
        const searchText = search.toLowerCase();

        return (
            (item.display_text).toLowerCase().includes(searchText)
        );
    });

    const totalRecords = filteredDictionaries.length;

    const totalPages = Math.ceil(totalRecords / pageSize);

    const paginatedDictionaries = filteredDictionaries.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );


    const startEntry =
        totalRecords === 0 ? 0 : (currentPage - 1) * pageSize + 1;

    const endEntry =
        totalRecords === 0
            ? 0
            : Math.min(currentPage * pageSize, totalRecords);

    const handleClose = (shouldRefresh = false) => {
        setIsDictionaryModalOpen(false);

        if (shouldRefresh) {
            fetchCkDictionaryLists();
        }
    };


    return (
        <div className="main-content">
            <div className="custom-header-ckdictionary">
                <span className="title">CK Dictionary</span>
                <button onClick={openAddDictionary} ><IoMdAdd /> Create CK Dictionary</button>
            </div>


            <div className="mt-3">

                <div className="pagination-wrapper-ckd">
                    <div className="search-wrapper-ckd">
                        <CiSearch className="search-icon" />
                        <input
                            type="text"
                            placeholder="Search by display name"
                            value={search}
                            className="form-control"
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>
                    <div className="right-wrapper-ckd">

                        {/* Limit Dropdown */}
                        <span className="showing-text">
                            Showing {startEntry} to {endEntry} of {totalRecords} entries
                        </span>

                        <span>Show</span>

                        <select
                            className="form-select"
                            value={pageSize}
                            onChange={(e) => handlePageSizeChange(e.target.value)}
                        >
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>


                        {/* Pagination */}
                        <ul className="pagination-ckd">
                            <li>
                                <button
                                    className="page-btn-ckd"
                                    disabled={currentPage === 1}
                                    onClick={() => setCurrentPage(currentPage - 1)}
                                >
                                    &lt;
                                </button>
                            </li>
                            <li>
                                <button className="page-btn-ckd page-btn-active">{currentPage}</button>
                            </li>
                            <li>
                                <button
                                    className="page-btn-ckd"
                                    disabled={currentPage === totalPages || paginatedDictionaries.length === 0}
                                    onClick={() => setCurrentPage(currentPage + 1)}
                                >
                                    &gt;
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
            <div className="table-content-ckd mt-3">
                <div className="ckd-table-wrapper">

                    <table className="ckd-table">
                        <thead className="thead-dark">
                            <tr>
                                <th>Ck Dictionary Id</th>
                                <th>Display Name</th>
                                <th>Display View</th>
                                <th>Item Collections Count</th>
                                <th>Preset Collections Count</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedDictionaries.length === 0 ? (
                                <tr>
                                    <td colSpan="5" className="text-center">No Records Found</td>
                                </tr>
                            ) : (
                                paginatedDictionaries.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.ck_dictionary_id || "NA"}</td>
                                        <td>{item.display_text || "NA"}</td>
                                        <td>{item.display_view}</td>
                                        <td>{item.item_groups_count || 0}</td>
                                        <td>{item.preset_groups_count || 0}</td>
                                        <td >
                                            <span className="action-icon">
                                                <FaEye onClick={() => {
                                                    setViewingObject(item.ck_dictionary_id)
                                                    setIsDictionaryModalOpen(true)
                                                    setIsEditModeOn(true)

                                                }} />
                                                <FaEdit onClick={() => openUpdateDictionary(item.ck_dictionary_id)} />
                                            </span>

                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

            </div>
            {isDictionaryModalOpen && (
                <ViewCk_Dictionary
                    ck_dictionaryid={viewingObject}
                    closeModal={handleClose}
                />
            )}





        </div>
    );
}

export default Ck_Dictionary;